<template>
    <v-simple-table dense class="mt-0 pt-0" style="background-color: transparent" v-if="serviceLevelAgreementProfile">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Respons<br />
              <v-tooltip top><template v-slot:activator="{ on, attrs }">
                  <v-icon small v-bind="attrs" v-on="on">mdi-alarm-light</v-icon>
                </template><span>fataal/urgent</span></v-tooltip> /
              <v-tooltip top><template v-slot:activator="{ on, attrs }">
                  <v-icon small v-bind="attrs" v-on="on">mdi-alarm-light-off-outline</v-icon>
                </template><span>niet fataal/urgent</span></v-tooltip>
            </th>
            <th class="text-left">
              Oplossen<br />
              <v-tooltip top><template v-slot:activator="{ on, attrs }">
                  <v-icon small v-bind="attrs" v-on="on">mdi-alarm-light</v-icon>
                </template><span>fataal/kritiek</span></v-tooltip> /
              <v-tooltip top><template v-slot:activator="{ on, attrs }">
                  <v-icon small v-bind="attrs" v-on="on">mdi-alarm-light-off-outline</v-icon>
                </template><span>niet fataal/kritiek</span></v-tooltip>
            </th>
            <th class="text-left">
              POH<br />interval
            </th>
            <th class="text-left">
              Rapport<br />
              POH / lus
            </th>
            <th class="text-left">
              Monitoring<br />
              Configuratie
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ $root.getSlaString(serviceLevelAgreementProfile.responseFatal) }} / {{
                $root.getSlaString(serviceLevelAgreementProfile.responseNonFatal)
            }}</td>
            <td>{{ $root.getSlaString(serviceLevelAgreementProfile.resolveUrgent) }} / {{
                $root.getSlaString(serviceLevelAgreementProfile.resolveNonUrgent)
            }}</td>
            <td>{{ serviceLevelAgreementProfile.preventiveMaintenancePeriodMonths }}mnd</td>
            <td>
              <v-icon v-if="serviceLevelAgreementProfile.preventiveMaintenanceReport" small
                color="success">
                mdi-check-circle</v-icon>
              <v-icon v-else small color="error">mdi-close-circle</v-icon> /
              <v-icon v-if="serviceLevelAgreementProfile.loopMaintenanceReport" small color="success">
                mdi-check-circle</v-icon>
              <v-icon v-else small color="error">mdi-close-circle</v-icon>
            </td>
            <td>
              <v-icon v-if="serviceLevelAgreementProfile.monitoringConfiguration" small
                color="success">
                mdi-check-circle</v-icon>
              <v-icon v-else small color="error">mdi-close-circle</v-icon>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
</template>

<style scoped lang="scss">  
  tbody {
     tr:hover {
        background-color: transparent !important;
     }
  }
</style>

<script>
export default {
  name: "ServiceLevelAgreementInfoTable",
  props: ['serviceLevelAgreementProfile'],
};
</script>